module.exports = __webpack_public_path__ + "img/banner-it.24840fe3.png";